module.exports = __webpack_public_path__ + "static/img/car-02.a7e06d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/album/car-02.jpg
// module id = 7KgY
// module chunks = 0